import getNumEnding from 'app/common/lib/getNumEnding'
import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'
import { PlainConfirm } from 'app/common/ui-next/plain-confirm-modal'

import styles from './SelectionActions.module.scss'
import { useCallback, useState } from 'react'
import useCallbackRef from 'app/common/hooks/useCallbackRef'
import { ActionButtonWithPrompt } from './dataTable/cell/ActionButtonWithPrompt'
import { EncashmentsAction } from 'app/dataTypes/reports/data/finances/encashments/action'


type Props = {
  onClickCancel: () => void
  onClickAction: (comment?: string) => Promise<boolean>
  selectionNumber: number
  selectionMode: EncashmentsAction
}

export const SelectionActions = ({
  onClickCancel,
  onClickAction,
  selectionNumber,
  selectionMode
}: Props) => {
  const [disabled, setDisabled] = useState<boolean>(false)
  const onClickActionRef = useCallbackRef(onClickAction)
  const itemName = getNumEnding(selectionNumber, ['заведение', 'заведения', 'заведений'])

  const handleAccept = useCallback(async () => {
    setDisabled(true)
    const res = await onClickActionRef.current?.()
    setDisabled(false)
    return !!res
  }, [onClickActionRef])

  const handleReject = useCallback(async (comment: string) => {
    setDisabled(true)
    const res = await onClickActionRef.current?.(comment)
    setDisabled(false)
    return !!res
  }, [onClickActionRef])


  const cancelBtnClass = selectionMode === 'accept'
    ? 'acceptCancelBtn'
    : 'rejectCancelBtn'

  return (
    <ControlsBar right>
      <div className={styles.text}>{`Выбрано: ${selectionNumber} ${itemName}`}</div>
      <PlainButton
        className={styles[cancelBtnClass]}
        onClick={onClickCancel}
        outline
      >
        {'Отмена'}
      </PlainButton>
      {selectionMode === EncashmentsAction.Accept &&
        <PlainConfirm
          messageText={'Подтвердить принятие наличных для всех выбранных точек продаж?'}
          onConfirm={handleAccept}
          closeRightAway
        >
          {onBeginConfirmation => (
            <PlainButton
              success
              onClick={onBeginConfirmation}
              disabled={selectionNumber === 0 || disabled}>
              {disabled ? 'обработка...' : 'Подтвердить выбранным'}
            </PlainButton>
          )}
        </PlainConfirm>}

      {selectionMode === EncashmentsAction.Reject &&
        <ActionButtonWithPrompt
          title="Отказать"
          confirmText={`Введите причину отказа для всех выбранных точек продаж`}
          onConfirm={handleReject}
        >
          {toggle => (
            <PlainButton
              onClick={toggle}
              disabled={disabled}
              danger
            >
              {disabled ? 'обработка...' : 'Отказать выбранным'}
            </PlainButton>
          )}
        </ActionButtonWithPrompt>}
    </ControlsBar>
  )
}
